module.exports = __webpack_public_path__ + "media/use_cases/slider-logo-1-cbaa76fd.png";